var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip-wrapper",on:{"mouseenter":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[_vm._t("default"),(_vm.show)?_c('div',{staticClass:"custom-tooltip-content"},[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }